import { DateTime } from "luxon";

export const DATE_TIME_OFFSET_FORMAT = "yyyy-LL-dd HH:mm 'UTC'ZZ";
export const DATE_TIME_FORMAT = "yyyy-LL-dd HH:mm";
export const DATE_FORMAT = "yyyy-LL-dd";
export const TIME_FORMAT = "HH:mm";

export const daysInMonth = (year: number, month: number): number => new Date(year, month, 0).getDate();

export const getCurrentTimestamp = (): number => Math.round(DateTime.now().toSeconds());